module.exports = __webpack_public_path__ + "static/media/hqm_threats.83463d4d.csv";